import HomeFleet from './HomeFleet_5_Full';
export default function App() { return <HomeFleet />; }
